import axios from 'axios';
import { BASE_URL, CURRENT_PROTOCOL } from '@/api/realApi/_constants';
export const axiosInstance = axios.create({
    baseURL: `${CURRENT_PROTOCOL}://${BASE_URL}`,
    withCredentials: true,
});
